module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-btn-radio u-relative u-cursor-pointer",
    class: [_vm.selected ? 'is-selected' : '']
  }, [_c('img', {
    staticClass: "u-relative c-btn-radio__hexagon u-force-3d",
    attrs: {
      "src": "/static/shape/shape-hexagon-outline--gray.png",
      "width": "40",
      "height": "48"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "u-absolute u-pos-center c-btn-radio__hexagon--selected u-force-3d",
    attrs: {
      "src": "/static/shape/shape-hexagon-filled--red.png",
      "width": "40",
      "height": "48"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "u-absolute u-pos-center c-btn-radio__check u-force-3d",
    attrs: {
      "src": "/static/shape/shape-check--red.png",
      "width": "18",
      "height": "14"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd27894a"}!./src/scripts/components/app-btn-radio/template.html
// module id = 943
// module chunks = 0